module.exports = __webpack_public_path__ + "static/img/routedes4.d692cc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/routedes4.jpg
// module id = QJlW
// module chunks = 0